<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/gas/stockLog"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="ctime">
          <DatePicker v-model="searchData.ctime" type="datetimerange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>
        <FormItem prop="type">
          <Select v-model="searchData.type" placeholder="分类">
            <Option value="">全部</Option>
            <Option value="recharge">系统编辑</Option>
            <Option value="order">订单消费</Option>
            <Option value="refund">退款</Option>
          </Select>
        </FormItem>
        <!-- 新增导出按钮 -->
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>


    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from "xlsx";

  export default {
    name: "companySn",
    components:{pageTable},
    props:{
      stationID:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          stationID:this.stationID,
          ctime:'',
          type: '',
        },
        tableColumn: [
          {title: 'ID',key: 'id',align: "center"},
          {title: '消费数量',key: 'litre_num',align: "center"},
          {title: '消费前数量',key: 'before_litre_num',align: "center"},
          {title: '消费后数量',key: 'after_litre_num',align: "center"},
          {title: '时间',key: 'ctime',align: "center",width:180},
          {title: '类型',key: 'type_name',align: "center"},
          // {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {
      // 导出
      exportData() {
        this.$commonFun.postProxy('admin/gas/exportStockLog',this.searchData).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`站点库存.xlsx`)
          })
        })
      }
    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>
